module.exports = __webpack_public_path__ + "img/otmsLoading.96c26b01.gif";